export default __webpack_public_path__ + "static/media/profile.44c4dca4.svg";